import { createContext, useCallback, useContext, useMemo, useState } from 'react'

const ModalContext = createContext(null)

export function ModalProvider({ children }) {
  const [barryOpen, setBarryOpen] = useState(false)
  const [founderOpen, setFounderOpen] = useState(false)

  const openBarry = useCallback(() => setBarryOpen(true), [])
  const closeBarry = useCallback(() => setBarryOpen(false), [])
  const openFounder = useCallback(() => setFounderOpen(true), [])
  const closeFounder = useCallback(() => setFounderOpen(false), [])

  const value = useMemo(
    () => ({
      barryOpen,
      founderOpen,
      openBarry,
      closeBarry,
      openFounder,
      closeFounder,
    }),
    [barryOpen, founderOpen, openBarry, closeBarry, openFounder, closeFounder],
  )

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
}

export function useModals() {
  const ctx = useContext(ModalContext)
  if (!ctx) throw new Error('useModals must be used within ModalProvider')
  return ctx
}
